/** Schema for various Resume Builder steps */

export const TOTAL_STEPS = 11;

export const LANDING_STEP = {
  index: 0,
  subSteps: {
    0: {
      index: 0,
      url: '',
    },
    1: {
      index: 1,
      url: 'intro',
      pageTitle: 'How to create a job-winning resume - Zippia',
    },
  },
  data: {},
};

export const EXPERIENCE_LEVEL_STEP = {
  index: 1,
  subSteps: {
    0: {
      index: 0,
      title: 'How Much Work Experience Do You Have?',
      url: 'job-level',
      pageTitle: 'Years of Experience - Zippia',
    },
  },
  data: {},
};

export const TEMPLATE_GALLERY_STEP = {
  index: 2,
  btnLabel: 'Resume Template',
  subSteps: {
    0: {
      index: 0,
      title: 'Choose A Custom Resume Template',
      url: 'choose-template',
      pageTitle: '10+ Professional Resume Templates - Zippia',
    },
  },
  data: {},
};

export const CONTACTS_STEP = {
  index: 3,
  btnLabel: 'Contact Info',
  navLabel: 'Contacts Info',
  subSteps: {
    0: {
      index: 0,
      title: 'Enter Your Contact Info',
      url: 'contacts',
      pageTitle: 'Contact Info - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const WORK_HISTORY_STEP = {
  index: 4,
  btnLabel: 'Work History',
  navLabel: 'Work History',
  subSteps: {
    0: {
      index: 0,
      title: 'Complete Your Work History',
      url: 'work-history-intro',
      pageTitle: 'Work History Intro - Zippia',
    },
    1: {
      index: 1,
      title: 'Enter Your Work History',
      url: 'employer-info',
      pageTitle: 'Work History - Zippia',
    },
    2: {
      index: 2,
      url: 'tasks-performed',
      pageTitle: 'Work History Tips - Zippia',
    },
    3: {
      index: 3,
      title: 'Your Work History',
      url: 'add-additional-experience',
      pageTitle: 'Work History - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const SIGNUP_STEP = {
  index: 5,
  subSteps: {
    0: {
      index: 0,
      url: 'sign-up',
      pageTitle: 'Resume Sign-up - Zippia',
    },
  },
};

export const EDUCATION_STEP = {
  index: 6,
  btnLabel: 'Education',
  navLabel: 'Education',
  subSteps: {
    0: {
      index: 0,
      title: "Let's Work On Your Education",
      url: 'education-intro',
      pageTitle: '',
    },
    1: {
      index: 1,
      title: 'Choose Your Highest Level Of Education',
      url: 'education-level',
      pageTitle: 'Education Level - Zippia',
    },
    2: {
      index: 2,
      title: 'Tell Us About Your Education',
      url: 'education-info',
      pageTitle: 'Education Info - Zippia',
    },
    3: {
      index: 3,
      title: 'Your Education',
      url: 'add-additional-education',
      pageTitle: 'Education Info - Zippia',
    },
  },
  data: {},
  errorFields: {},
};

export const SKILLS_STEP = {
  index: 7,
  btnLabel: 'Skills',
  navLabel: 'Skills',
  subSteps: {
    0: {
      index: 0,
      title: "Let's Take Care Of Your Skills",
      url: 'skill-intro',
      pageTitle: 'Skills - Zippia',
    },
    1: {
      index: 1,
      title: 'Select Your Skills',
      url: 'add-skills',
      pageTitle: 'Add Skills - Zippia',
    },
  },
  data: {},
};

export const OTHERS_STEP = {
  index: 8,
  btnLabel: 'Others',
  navLabel: 'Others',
  subSteps: {
    0: {
      index: 0,
      title: 'Add Additional Sections To Your Resume',
      url: 'other-intro',
      pageTitle: 'Other Tips - Zippia',
    },
    1: {
      index: 1,
      title: 'What Certifications Do You Have?',
      url: 'certification-info',
      pageTitle: 'Add Certifications - Zippia',
    },
    2: {
      index: 2,
      title: 'Your Languages',
      url: 'language-info',
      pageTitle: 'Add Languages - Zippia',
    },
  },
  data: {
    customSections: {},
  },
};

export const SUMMARY_STEP = {
  index: 9,
  btnLabel: 'Summary',
  navLabel: 'Summary',
  subSteps: {
    0: {
      index: 0,
      title: "Last But Not The Least, Let's Work On Your Summary",
      url: 'summary-intro',
      pageTitle: 'Summary Intro - Zippia',
    },
    1: {
      index: 1,
      title: 'Write Your Summary',
      url: 'summary-info',
      pageTitle: 'Summary Tips - Zippia',
    },
  },
  data: {},
};

export const PREVIEW_STEP = {
  index: 10,
  btnLabel: 'Preview',
  navLabel: 'Preview',
  hideBack: true,
  subSteps: {
    0: {
      index: 0,
      title: 'Preview',
      url: 'resume-preview',
      pageTitle: 'Finalize Resume - Zippia',
    },
  },
};

// Schema of all Steps = 11 steps
export const ResumeBuilderSchema = {
  0: LANDING_STEP,
  1: EXPERIENCE_LEVEL_STEP,
  2: TEMPLATE_GALLERY_STEP,
  3: CONTACTS_STEP,
  4: WORK_HISTORY_STEP,
  5: SIGNUP_STEP,
  6: EDUCATION_STEP,
  7: SKILLS_STEP,
  8: OTHERS_STEP,
  9: SUMMARY_STEP,
  10: PREVIEW_STEP,
};
